import { render } from "./ChannelsCard.vue?vue&type=template&id=00fdb556"
import script from "./ChannelsCard.vue?vue&type=script&lang=js"
export * from "./ChannelsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__